"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationOut = void 0;
class ApplicationOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ApplicationOut.attributeTypeMap;
    }
}
exports.ApplicationOut = ApplicationOut;
ApplicationOut.discriminator = undefined;
ApplicationOut.attributeTypeMap = [
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "metadata",
        "baseName": "metadata",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=ApplicationOut.js.map